<template>
  <UiContainer class="privacy-view" :max-width="800">
    <h1 class="privacy-view__title">Политика обработки персональных данных</h1>

    <div class="privacy-view__body">
      <p>
        Настоящая Политика определяет порядок и условия обработки персональных данных пользователей
        сервиса «ЛабАктив».
      </p>

      <h2>1. Общие положения и оператор персональных данных</h2>
      <p>
        Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
        персональных данных», а также иными нормативными актами РФ в области защиты персональных
        данных.
      </p>
      <p>
        Оператор персональных данных:
        <strong>Колупаева Мария Максимовна</strong>.<br />
        Email для вопросов о персональных данных:
        <a href="mailto:mkolupaeva@labactive.ru">mkolupaeva@labactive.ru</a>.
      </p>

      <h2>2. Категории субъектов и состав обрабатываемых данных</h2>
      <p>
        Оператор обрабатывает данные посетителей сайта, зарегистрированных пользователей,
        представителей компаний, поставщиков и лиц, направивших обращение, включая:
      </p>
      <ul>
        <li>фамилия, имя, отчество;</li>
        <li>контактные данные (email, телефон);</li>
        <li>данные учётной записи, сведения об авторизации и настройках уведомлений;</li>
        <li>сведения о компании и её представителях, если они введены пользователем;</li>
        <li>данные заказов, заявок на обратную связь, обращений и переписки с поддержкой;</li>
        <li>технические данные: IP-адрес, сведения о браузере, cookie и сессионные данные.</li>
      </ul>

      <h2>3. Цели обработки данных</h2>
      <p>Персональные данные обрабатываются в целях:</p>
      <ul>
        <li>регистрации и ведения учётной записи пользователя;</li>
        <li>обработки заказов, заявок и исполнения обязательств перед пользователем;</li>
        <li>коммуникации с пользователями, в том числе через службу поддержки;</li>
        <li>обеспечения безопасности, предотвращения злоупотреблений и мошенничества;</li>
        <li>диагностики технических ошибок и улучшения работы сервиса;</li>
        <li>
          направления рекламных и маркетинговых сообщений только при наличии отдельного согласия.
        </li>
      </ul>

      <h2>4. Правовые основания обработки</h2>
      <p>Обработка персональных данных осуществляется на следующих основаниях:</p>
      <ul>
        <li>согласие субъекта персональных данных;</li>
        <li>исполнение договора, стороной которого является субъект персональных данных;</li>
        <li>исполнение обязанностей оператора, установленных законодательством РФ;</li>
        <li>
          осуществление прав и законных интересов оператора при соблюдении прав субъектов ПДн.
        </li>
      </ul>

      <h2>5. Способы обработки и передача данных</h2>
      <p>
        Обработка персональных данных включает сбор, запись, систематизацию, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передачу (предоставление,
        доступ), обезличивание, блокирование, удаление и уничтожение персональных данных.
      </p>
      <p>
        Обработка преимущественно осуществляется с использованием средств автоматизации. Доступ к
        данным получают только лица, которым он необходим для работы сервиса и обработки обращений.
      </p>
      <p>
        Передача данных подрядчикам допускается только в объёме, необходимом для работы сервиса,
        исполнения обязательств или выполнения требований закона. При подключении нового сервиса,
        который получает персональные данные, Политика будет обновлена до его включения.
      </p>

      <h2>6. Сроки хранения и удаление данных</h2>
      <p>
        Данные учётной записи хранятся в течение срока её использования. Данные обращений и заявок
        хранятся до завершения соответствующего обращения, если более длительный срок не требуется
        законодательством РФ или защитой прав оператора.
      </p>
      <p>
        Пользователь может направить запрос на уточнение, удаление или прекращение обработки данных
        на <a href="mailto:mkolupaeva@labactive.ru">mkolupaeva@labactive.ru</a>. Данные удаляются или
        обезличиваются после достижения цели обработки либо по запросу пользователя, если их
        хранение не требуется по закону.
      </p>

      <h2>7. Cookie, аналитика и мониторинг ошибок</h2>
      <p>
        Сервис использует технические cookie и сессионные данные для авторизации, безопасности и
        корректной работы сайта. Их отключение в браузере может ограничить часть функциональности.
      </p>
      <p>
        Посетительская аналитика и внешние системы мониторинга ошибок не включаются без отдельной
        проверки условий обработки данных и обновления настоящей Политики.
      </p>

      <h2>8. Права субъекта персональных данных</h2>
      <p>Субъект персональных данных имеет право:</p>
      <ul>
        <li>получать информацию об обработке его персональных данных;</li>
        <li>требовать уточнения, блокирования или уничтожения его персональных данных;</li>
        <li>отозвать согласие на обработку персональных данных;</li>
        <li>обжаловать действия оператора в уполномоченный орган или в судебном порядке.</li>
      </ul>

      <h2>9. Меры защиты персональных данных</h2>
      <p>
        Оператор принимает необходимые правовые, организационные и технические меры для защиты
        персональных данных от неправомерного или случайного доступа, уничтожения, изменения,
        блокирования, копирования, предоставления, распространения и иных неправомерных действий.
      </p>

      <h2>10. Контактная информация</h2>
      <p>
        По вопросам обработки персональных данных и реализации прав субъекта ПДн обращайтесь:
        <a href="mailto:mkolupaeva@labactive.ru">mkolupaeva@labactive.ru</a>.
      </p>

      <p class="privacy-view__updated">Редакция от 08.09.2026</p>
    </div>
  </UiContainer>
</template>

<script setup lang="ts">
import UiContainer from '@/shared/ui/UiContainer.vue'
</script>

<style scoped>
.privacy-view {
  padding-top: 24px;
  padding-bottom: 48px;
}

.privacy-view__title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
}

.privacy-view__body {
  line-height: 1.7;
  font-size: 15px;
}

.privacy-view__body p {
  margin: 0 0 16px;
}

.privacy-view__body h2 {
  margin: 32px 0 12px;
  font-size: 18px;
  font-weight: 600;
}

.privacy-view__body ul {
  margin: 0 0 16px;
  padding-left: 20px;
}

.privacy-view__body li {
  margin-bottom: 8px;
}

.privacy-view__body a {
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
}

.privacy-view__body a:hover {
  text-decoration: underline;
}

.privacy-view__updated {
  margin-top: 32px;
  font-size: 14px;
  color: #586578;
}
</style>
